import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { WhatsAppTemplateCategoryEnum } from '../../shared';

@Component({
  selector: 'app-whatsapp-template-category',
  templateUrl: './whatsapp-template-category.component.html',
  styleUrls: ['./whatsapp-template-category.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WhatsappTemplateCategoryComponent {
  @Input() form: FormGroup;
  categories: string[] = Object.keys(WhatsAppTemplateCategoryEnum).map(i => i.toLowerCase());
}
